package ui.screens.section.hero

import androidx.compose.animation.AnimatedVisibilityScope
import androidx.compose.animation.ExperimentalSharedTransitionApi
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.dp
import ui.composables.BackgroundTexture
import ui.screens.home.bgTexture
import ui.screens.section.hero.composable.EditorialBackground
import ui.screens.section.hero.composable.HeroImage
import ui.theme.bgColor
import ui.theme.fgColor

@OptIn(ExperimentalSharedTransitionApi::class)
@Composable
fun HeroSection(
    safeEntered: Boolean,
    bgAlpha1: Float,
    animatedVisibilityScope: AnimatedVisibilityScope,
    bgPainter: Painter,
) {
    Box(
        Modifier
            .fillMaxSize()
            .background(fgColor)
    )

    // ===== CONTENT =====
    Column {
        BackgroundTexture(
            texture = bgTexture,
            alpha = 0.3f,
            modifier = Modifier
                .fillMaxWidth()
                .height(250.dp)
        )

        Box(
            Modifier
                .scale(1.2f)
                .fillMaxWidth()
                .weight(1f)
                .background(bgColor)
        )
    }

    HeroImage(
        entered = safeEntered,
        animatedVisibilityScope = animatedVisibilityScope
    )

    EditorialBackground(
        alpha = bgAlpha1,
        bgPainter
    )
}